module.exports = __webpack_public_path__ + "static/media/mariopipe.51562a9e.png";